





























































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { DataTableHeader } from "vuetify";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import PasienMultiWarningIndicator from "@/components/icons/PasienMultiWarningIndicator.vue";
import { userModule } from "@/store/modules/user";
import { storePasien } from "@/store/modules/pasien";
import DaftarPasienPendaftaran from "@/services/DaftarPasienPendaftaran";
import PasienNew from "@/services/PasienNew";
import { localISODate } from "@/utils/localDate";
import { isUnitRekamMedis } from "@/utils/unit";
import { tagIndicatorByRm } from "@/utils/pasienTag";
import { SKRINING_PASIEN_TAB } from "@/utils/ralanFormRegistry";
import { PasienTagByRm } from "@/types/daftarPasienPenunjang";
import {
  JenisRuang,
  JenisRuangFilter,
  PasienPendaftaranParams,
  PasienPendaftaranRow,
  PasienPendaftaranTableOptions
} from "@/types/daftarPasienPendaftaran";

const JENIS_RUANG_LABEL: Record<JenisRuang, string> = {
  ralan: "Rawat Jalan",
  ranap: "Rawat Inap",
  igd: "IGD"
};

const JENIS_RUANG_COLOR: Record<JenisRuang, string> = {
  ralan: "teal",
  ranap: "indigo",
  igd: "red"
};

const UNIT_IGD = "01";
const UNIT_REKAM_MEDIS = "80";
const CARI_DEBOUNCE_MS = 400;
const TINGGI_TABEL_MIN = 240;
const RUANG_BAWAH_TABEL = 32;

function parseTanggal(val: string | null): Date | null {
  if (!val) {
    return null;
  }

  const p = val.split("-").map(Number);

  return new Date(p[0], p[1] - 1, p[2]);
}

@Component({
  components: {
    VCDateTimePicker,
    UnitRuangPicker,
    PasienMultiWarningIndicator
  }
})
export default class DaftarPasienPendaftaranPage extends Vue {
  tglStart: string = localISODate();
  tglEnd: string = localISODate();
  jenisRuang: JenisRuangFilter = "semua";
  unit: string | null = null;
  cari = "";
  q = "";

  items: PasienPendaftaranRow[] = [];
  totalItems = 0;
  pasienTagByRm: PasienTagByRm = {};
  loading = false;
  errList = false;

  footerProps = {
    "items-per-page-options": [25, 50, 100],
    "items-per-page-text": "Baris per halaman",
    "page-text": "{0}-{1} dari {2}"
  };
  options: PasienPendaftaranTableOptions = { page: 1, itemsPerPage: 25 };

  jenisRuangOptions: { text: string; value: JenisRuangFilter }[] = [
    { text: "Semua", value: "semua" },
    { text: JENIS_RUANG_LABEL.ralan, value: "ralan" },
    { text: JENIS_RUANG_LABEL.ranap, value: "ranap" },
    { text: JENIS_RUANG_LABEL.igd, value: "igd" }
  ];

  jenisRuangLabel = JENIS_RUANG_LABEL;
  jenisRuangColor = JENIS_RUANG_COLOR;

  get headers(): DataTableHeader[] {
    const kolom: DataTableHeader[] = [
      { text: "Pasien (RM · JK)", value: "pasien.nama" },
      { text: "Indikator", value: "indikator", align: "center", width: "70px" },
      { text: "Alamat", value: "pasien.alamat" },
      { text: "Register / SEP", value: "register_id" },
      { text: "Masuk", value: "tgl_in" },
      { text: "Unit / Jenis Ruang", value: "unit.nama" },
      { text: "DPJP", value: "dokter.nama" },
      { text: "Jaminan", value: "cara_bayar" }
    ];

    if (this.modeRekamMedis) {
      kolom.push({
        text: "Rekam Medis",
        value: "rekam_medis",
        align: "center",
        width: "100px"
      });
    }

    kolom.push({
      text: "Riwayat",
      value: "aksi",
      align: "center",
      width: "70px"
    });

    return kolom;
  }

  tinggiTabel = TINGGI_TABEL_MIN;

  private reqToken = 0;
  private cariTimer: number | null = null;
  private muatTerjadwal = false;

  mounted() {
    window.addEventListener("resize", this.hitungTinggiTabel);
    this.$nextTick(this.hitungTinggiTabel);
    this.jadwalkanMuat();
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.hitungTinggiTabel);
    this.batalkanCari();
  }

  hitungTinggiTabel() {
    const tabel = this.$refs.tabel as Vue | undefined;
    const wrapper = tabel
      ? (tabel.$el.querySelector(
          ".v-data-table__wrapper"
        ) as HTMLElement | null)
      : null;

    if (!tabel || !wrapper) return;

    const footer = tabel.$el.querySelector(
      ".v-data-footer"
    ) as HTMLElement | null;
    const atas = wrapper.getBoundingClientRect().top + window.pageYOffset;
    const bawah = (footer ? footer.offsetHeight : 0) + RUANG_BAWAH_TABEL;

    this.tinggiTabel = Math.max(
      TINGGI_TABEL_MIN,
      Math.floor(window.innerHeight - atas - bawah)
    );
  }

  get stateuser() {
    return userModule.user;
  }

  get modeRekamMedis(): boolean {
    return isUnitRekamMedis(userModule.loginUnitId);
  }

  get tglStartDate(): Date | null {
    return parseTanggal(this.tglStart);
  }

  get tglEndDate(): Date | null {
    return parseTanggal(this.tglEnd);
  }

  get unitKategori(): string[] {
    if (this.jenisRuang === "ralan") {
      return ["ralan", "penunjang"];
    }

    if (this.jenisRuang === "ranap") {
      return ["ranap"];
    }

    return [];
  }

  get unitDikecualikan(): string[] {
    return this.jenisRuang === "ralan"
      ? [UNIT_IGD, UNIT_REKAM_MEDIS]
      : [UNIT_REKAM_MEDIS];
  }

  get tagIndicatorByRm(): Record<string, string[]> {
    return tagIndicatorByRm(
      this.pasienTagByRm,
      storePasien.pasientTagAttribute
    );
  }

  setTglStart(val: Date | null) {
    this.tglStart = val ? localISODate(val) : localISODate();

    if (this.tglEnd < this.tglStart) {
      this.tglEnd = this.tglStart;
    }
  }

  setTglEnd(val: Date | null) {
    this.tglEnd = val ? localISODate(val) : localISODate();

    if (this.tglEnd < this.tglStart) {
      this.tglStart = this.tglEnd;
    }
  }

  setCari(val: string | null) {
    this.cari = val || "";
    this.batalkanCari();
    this.cariTimer = window.setTimeout(() => {
      this.cariTimer = null;
      this.q = this.cari.trim();
    }, CARI_DEBOUNCE_MS);
  }

  batalkanCari() {
    if (this.cariTimer !== null) {
      window.clearTimeout(this.cariTimer);
      this.cariTimer = null;
    }
  }

  resetFilter() {
    this.batalkanCari();
    this.tglStart = localISODate();
    this.tglEnd = localISODate();
    this.jenisRuang = "semua";
    this.unit = null;
    this.cari = "";
    this.q = "";
  }

  @Watch("jenisRuang")
  onJenisRuangChange() {
    this.unit = null;
    this.onFilterChange();
  }

  @Watch("tglStart")
  @Watch("tglEnd")
  @Watch("unit")
  @Watch("q")
  onFilterChange() {
    if (this.options.page !== 1) {
      this.options = { ...this.options, page: 1 };
    }

    this.jadwalkanMuat();
  }

  @Watch("options", { deep: true })
  onOptionsChange() {
    this.jadwalkanMuat();
  }

  jadwalkanMuat() {
    if (this.muatTerjadwal) return;

    this.muatTerjadwal = true;
    this.$nextTick(() => {
      this.muatTerjadwal = false;
      this.muatDaftar();
    });
  }

  buildParams(): PasienPendaftaranParams {
    const params: PasienPendaftaranParams = {
      page: this.options.page,
      per_page: this.options.itemsPerPage,
      tgl_start: this.tglStart,
      tgl_end: this.tglEnd
    };

    if (this.jenisRuang !== "semua") {
      params.jenis_ruang = this.jenisRuang;
    }

    if (this.unit && this.jenisRuang !== "igd") {
      params.unit = this.unit;
    }

    if (this.q) {
      params.q = this.q;
    }

    return params;
  }

  muatDaftar() {
    this.loading = true;
    this.errList = false;

    const token = ++this.reqToken;

    DaftarPasienPendaftaran.getList(this.buildParams())
      .then(resp => {
        if (token !== this.reqToken) return;

        this.items = Array.isArray(resp.data) ? resp.data : [];
        this.totalItems = resp.meta ? resp.meta.total : this.items.length;
        this.muatPasienTag(token);
      })
      .catch(() => {
        if (token !== this.reqToken) return;

        this.errList = true;
        this.items = [];
        this.totalItems = 0;
        this.pasienTagByRm = {};
      })
      .finally(() => {
        if (token !== this.reqToken) return;

        this.loading = false;
      });
  }

  muatPasienTag(token: number) {
    const rms = Array.from(
      new Set(
        this.items
          .map(row => (row.pasien && row.pasien.rm ? row.pasien.rm : ""))
          .filter(rm => rm !== "")
      )
    );

    if (!rms.length) {
      this.pasienTagByRm = {};
      return;
    }

    PasienNew.getMultiPasienTag(rms)
      .then((resp: PasienTagByRm) => {
        if (token !== this.reqToken) return;

        this.pasienTagByRm = resp && !Array.isArray(resp) ? resp : {};
      })
      .catch(() => undefined);
  }

  riwayatPemeriksaan(item: PasienPendaftaranRow) {
    if (!item || !item.pasien || !item.pasien.rm) return;

    this.$router.push({
      name: "detail-pasien",
      params: { rm: item.pasien.rm }
    });
  }

  bukaSkrining(item: PasienPendaftaranRow) {
    if (!item || !item.register_id || !item.pasien || !item.pasien.rm) return;

    this.$router.push({
      name: "pemeriksaan",
      params: {
        register: String(item.register_id),
        rm: item.pasien.rm
      },
      query: {
        topTab: "tab-assesmen",
        tab: SKRINING_PASIEN_TAB
      }
    });
  }
}
